
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PERMISSIONS } from '../../../../constants';
import { checkPermisson } from '../../../../selectors/common';
import { getDownloadedLiveTemplateFile, getLiveTemplateFile } from '../../../../selectors/teams';
import PlayersTemplateFile from '../..';
import { aDownaloadLiveTemplateFileRequest, aGetLiveTemplateFileRequest, aSaveLiveTemplateFileRequest } from '../../../../reducers';

const mapToProps = (state) => ({
  downloadedTemplateFile: getDownloadedLiveTemplateFile(state),
  liveTemplateFile: getLiveTemplateFile(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
});

const actionsToProps = (dispatch) => ({
  getLiveTemplateFileRequest: (payload) => dispatch(aGetLiveTemplateFileRequest(payload)),
  uploadLiveTemplateFileRequest: (payload) => dispatch(aSaveLiveTemplateFileRequest(payload),
  ),

  downloadLiveTemplatesFile: (payload) => dispatch(aDownaloadLiveTemplateFileRequest(payload)),
});
class SoccerLiveTemplateFile extends Component {
  constructor(props) {
    super(props);
    this.hasPermissionTo = {
      view: props.checkPermisson(PERMISSIONS.LIVE_TEMPLATES_FILES_VIEW),
      upload: props.checkPermisson(PERMISSIONS.LIVE_TEMPLATE_UPLOAD),
      download: props.checkPermisson(PERMISSIONS.LIVE_TEMPLATES_VIEW),
    };
  }

  componentDidMount() {
    this.props.getLiveTemplateFileRequest();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.downloadedTemplateFile !== this.props.downloadedTemplateFile) {
      window.location.assign(this.props.downloadedTemplateFile.url);
    }
  }

  render() {
    return (
      <PlayersTemplateFile
        playersTemplateFile={this.props.liveTemplateFile}
        uploadPlayersTemplateFileRequest={this.props.uploadLiveTemplateFileRequest}
        hasPermissionToUpload={this.hasPermissionTo.upload}
        hasPermissionToView={this.hasPermissionTo.view}
        hasPermissionToDownload={this.hasPermissionTo.download}
        downloadPlayersTemplatesFile={this.props.downloadLiveTemplatesFile}
      />
    );
  }
}

export default connect(mapToProps, actionsToProps)(SoccerLiveTemplateFile);
